/**
 * DevExtreme (esm/ui/scroll_view.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import ScrollView from "./scroll_view/ui.scroll_view";
export default ScrollView;
